import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface DesignerRightPanelProps {
    show: boolean;
    minWidth?: string;
    width?: string;
    maxWidth?: string;
    shouldCloseOnOverlayClick?: boolean;
    overlayBackgroundColor?: string;
    contentBackgroundColor?: string; // header
    bodyBackgroundColor?: string;
    title?: string;
    children: React.ReactNode;
    onClose: () => void;
    disableOnClose?: boolean;
};

Modal.setAppElement('#root');

const DesignerRightPanel: React.FC<DesignerRightPanelProps> = (props: DesignerRightPanelProps) => {

    const customStyles = {
        overlay: {
            backgroundColor: props.overlayBackgroundColor ?? 'rgba(0, 0, 0, .8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'flex-end',
        },
        content : {
            inset                 : 'unset',
            top                   : '0',
            bottom                : '0',
            minWidth              : props.minWidth ?? '30vw',
            width                 : props.width ?? "30vw",
            maxWidth              : props.maxWidth ?? '100vw',
            height                : '100vh',
            border                : 'none',
            backgroundColor       : props.contentBackgroundColor ?? '#121212',
            overflow              : 'auto',
        },
    };

    const [modalIsOpen, setIsOpen] = useState<boolean>(props.show);

    useEffect(() => {
        setIsOpen(props.show);
    }, [props.show]);

    let bodyBackgroundColorStr: string = props.bodyBackgroundColor ?? "#151515";

    const _renderHeader = () => {

        return(
            <div>
                <div className="d-flex align-items-center px-3 py-2">
                    <span className="font-weight-bold">{props.title ?? ""}</span>
                    <div 
                        className="ml-auto pointer p-2"
                        onClick={() => {
                            if(props.disableOnClose) return;
                            props.onClose();
                        }}
                    >
                        <FontAwesomeIcon 
                            icon={faTimes}
                            fill={props.disableOnClose ? "#333333" : "#969696"}
                            size="1x"
                        />
                    </div>
                </div>
                <hr className="m-0 bg-hr-color" />
            </div>
        );

    }

    return(
        <>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => props.onClose()}
                style={customStyles}
                shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick ?? false}
            >
                {_renderHeader()}
                <div className="p-3" style={{ backgroundColor: bodyBackgroundColorStr, minHeight: 'calc(100vh - 56px)', }}>
                    {props.children}
                </div>
            </Modal>
        </>
    );
    

};

export default React.memo(DesignerRightPanel);
